import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);
//按需加载,当渲染其他页面时才加载其组件,并缓存,减少首屏加载时间
const Index = resolve => require(['@/views/Index.vue'], resolve)
const wallet = resolve => require(['@/views/wallet.vue'], resolve)
const invite = resolve => require(['@/views/invite.vue'],resolve)
const User = resolve => require(['@/views/User.vue'], resolve)
const charge = resolve => require(['@/views/charge.vue'], resolve)
const applyCard = resolve => require(['@/views/applyCard.vue'], resolve)
const payCard = resolve => require(['@/views/payCard.vue'], resolve)
const Pay = resolve => require(['@/components/car/pay/pay.vue'], resolve)
const Login = resolve => require(['@/views/login.vue'], resolve)
const equity = resolve => require(['@/views/equity.vue'], resolve)
const indexRecord = resolve => require(['@/views/indexRecord.vue'], resolve)
const exchangeRecord = resolve => require(['@/views/exchangeRecord.vue'], resolve)
const inviteDetail = resolve => require(['@/views/inviteDetail.vue'], resolve)
const xieyiList = resolve => require(['@/views/xieyiList.vue'], resolve)
const register = resolve => require(['@/views/register.vue'], resolve)
const moneyDetail = resolve => require(['@/views/moneyDetail.vue'], resolve)
const transfer = resolve => require(['@/views/transfer.vue'], resolve)
const bindPhone = resolve => require(['@/views/bindPhone.vue'], resolve)
const bindEmail = resolve => require(['@/views/bindEmail.vue'], resolve)
const changePass = resolve => require(['@/views/changePass.vue'], resolve)
const forgetPoss = resolve => require(['@/views/forgetPoss.vue'], resolve)
const xieyiDetail = resolve => require(['@/views/xieyiDetail.vue'], resolve)
const annouCenter = resolve => require(['@/views/annouCenter.vue'], resolve)
const question = resolve => require(['@/views/question.vue'], resolve)
const cvv = resolve => require(['@/views/cvv.vue'], resolve)
const KYCcerty = resolve => require(['@/views/KYCcerty.vue'], resolve)
const rechargeCurr = resolve => require(['@/views/rechargeCurr.vue'], resolve)
const chargeRecord = resolve => require(['@/views/chargeRecord.vue'], resolve)
const saoyisao = resolve => require(['@/views/saoyisao.vue'], resolve)
const result = resolve => require(['@/views/result.vue'], resolve)
const kefu = resolve => require(['@/views/kefu.vue'], resolve)
const recordDetail = resolve => require(['@/views/recordDetail.vue'], resolve)
const chongzhiRecord = resolve => require(['@/views/chongzhiRecord.vue'], resolve)
const chongzhiDetail = resolve => require(['@/views/chongzhiDetail.vue'], resolve)

export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: '首页',
      component: Index
    }, {
      path: '/wallet',
      name: '钱包',
      component: wallet,
    },  {
      path: '/moneyDetail',
      name: '余额明细',
      component: moneyDetail,
      meta: {
        requireAuth: true,  
    }
    },{
      path: '/transfer',
      name: '转账',
      component: transfer,
      meta: {
        requireAuth: true,  
    }
    },{
      path: '/invite',
      name: '邀请',
      component: invite
    }, {
      path: '/inviteDetail',
      name: '邀请记录',
      component: inviteDetail,
      meta: {
        requireAuth: true,  
    },
    },{
      path: '/indexRecord',
      name: '全部记录',
      component: indexRecord,
      meta: {
        requireAuth: true,  
    },
    }, {
      path: '/exchangeRecord',
      name: '兑换记录',
      component: exchangeRecord,
      meta: {
        requireAuth: true,  
    },
    },{
      path: '/cvv',
      name: '安全码',
      component: cvv,
      meta: {
        requireAuth: true,  
    },
    },
    {
      path: '/equity',
      name: '权益',
      component: equity,
      meta: {
        requireAuth: true,  
    },
    },
    {
      path: '/chargeRecord',
      name: '充值明细',
      component: chargeRecord,
      meta: {
        requireAuth: true,  
    },
    },
    {
      path: '/chongzhiRecord',
      name: '充值记录',
      component: chongzhiRecord,
      meta: {
        requireAuth: true,  
    },
    },
    {
      path: '/chongzhiDetail',
      name: '充值详情',
      component: chongzhiDetail,
      meta: {
        requireAuth: true,  
    },
    },
    {
      path: '/user',
      name: '我的',
      component: User,
      // meta: {
      //      requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录才能进入的
      //  },
    }, {
      path: '/changePass',
      name: '修改密码',
      component: changePass,
      meta: {
           requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录才能进入的
       },
    },{
      path: '/forgetPoss',
      name: '重置密码',
      component: forgetPoss,
    },
     {
      path: '/bindPhone',
      name: '手机',
      component: bindPhone,
      meta: {
           requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录才能进入的
       },
    },{
      path: '/bindEmail',
      name: '邮箱',
      component: bindEmail,
      meta: {
           requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录才能进入的
       },
    },
    {
      path: '/charge',
      name: '充值',
      component: charge,
      meta: {
        requireAuth: true,  
    },
    }, {
      path: '/applyCard',
      name: '申请卡',
      component: applyCard,
           meta: {
           requireAuth: true,  
       },
    },{
      path: '/payCard',
      name: '卡付款',
      component: payCard,
      meta: {
        requireAuth: true,  
    },
    },{
      path: '/login',
      name: '登录',
      component: Login
    },{
      path: '/xieyiList',
      name: '协议',
      component: xieyiList  
    },{
      path: '/register',
      name: '注册',  
      component: register
    },{
      path: '/xieyiDetail',
      name: '协议详情',
      component: xieyiDetail
    },{
      path: '/annouCenter',
      name: '公告中心',
      component: annouCenter
    }
    ,{
      path: '/question',
      name: '常见问题',
      component: question
    },{
      path: '/KYCcerty',
      name: '认证',
      component: KYCcerty,
      meta: {
        requireAuth: true,  
    },
    },{
      path: '/rechargeCurr',
      name: '充币',
      component: rechargeCurr,
      meta: {
        requireAuth: true,  
    },
    },{
      path: '/saoyisao',
      name: '扫一扫',
      component: saoyisao,
      meta: {
        requireAuth: true,  
    },
    },{
      path: '/result',
      name: '注销确认',
      component: result,
      meta: {
        requireAuth: true,  
    },
    },{
      path: '/kefu',
      name: '客服',
      component: kefu,
    },{
      path: '/recordDetail',
      name: '记录详情',
      component: recordDetail,
    }
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js